import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { EditPopupConfigurations } from "../../../EditPopupConfigurations";
import { handleNotificationForItem, serializeRecordForModal } from "../../ItemsConfig/ItemsConfig";

const ItemCreateEditModal = ({ isModelOpen, record, onCloseModal, onSuccess, setItemData, isToEdit,
    removeFetch, isFetching, isSuccess, isError, error }) => {

    const { t } = useTranslation();

    const handleOk = (newItemData) => {
        const itemToUpdate = { ...newItemData };

        if (isToEdit) {
            itemToUpdate.id = record.itemId;
        }
        setItemData(itemToUpdate);
    }

    useEffect(() => {
        handleNotificationForItem(isFetching, isSuccess, isError, error, isToEdit, t);

        if (!isFetching && isSuccess) {
            handleSuccess();
        }

    }, [isSuccess, isError, isFetching]);

    const handleSuccess = () => {
        if (onSuccess) {
            onSuccess();
        }
        onCloseModal();
    }

    useEffect(() => {
        return () => {
            removeFetch();
        }
    }, []);

    return (
        <EditPopupConfigurations
            isToEdit={isToEdit}
            openModal={isModelOpen}
            closeModal={onCloseModal}
            selectedRecord={record ? serializeRecordForModal(record, t) : null}
            customWidth={1120}
            onOkModal={(data) => {
                handleOk(data);
            }}
            loading={isFetching}
        />
    )

}

export default ItemCreateEditModal;